import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';

import type { IActivityData } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface IProps {
  data: IActivityData;
}

const PatientNameColumn: React.FC<IProps> = ({ data }) => {
  return (
    <div>
      <Link to={Routes.patientGuid(data.patient.guid)}>
        <strong>
          {data.patient.firstName} {data.patient.lastName}
        </strong>
      </Link>
    </div>
  );
};

export default PatientNameColumn;
